import produce from 'immer';

import {
  CONTACT_CUSTOM_FIELD_CREATE_FAILURE,
  CONTACT_CUSTOM_FIELD_CREATE_SUCCESS,
  CONTACT_CUSTOM_FIELD_EDIT_FAILURE,
  CONTACT_CUSTOM_FIELD_EDIT_SUCCESS,
  CONTACT_CUSTOM_FIELD_FETCH_FAILURE,
  CONTACT_CUSTOM_FIELD_FETCH_SUCCESS,
  CONTACT_CUSTOM_FIELDS_FETCH_FAILURE,
  CONTACT_CUSTOM_FIELDS_FETCH_SUCCESS,
  CONTACT_CUSTOM_FIELDS_SEQUENCE_EDIT_FAILURE,
  CONTACT_CUSTOM_FIELDS_SEQUENCE_EDIT_SUCCESS,
} from '@actions/contactCustomField';

const initialState: IContactCustomFieldStore = {
  contactCustomFields: null,
  currentContactCustomField: null,
  error: null,
  isFetching: null,
};

export default (state: IContactCustomFieldStore = initialState, action: any) =>
  produce(state, (draftState: IContactCustomFieldStore) => {
    switch (action.type) {
      case CONTACT_CUSTOM_FIELDS_FETCH_FAILURE:
        draftState.isFetching = true;
        draftState.contactCustomFields = null;
        draftState.error = action.error;

        return;

      case CONTACT_CUSTOM_FIELDS_FETCH_SUCCESS:
        draftState.isFetching = true;
        draftState.contactCustomFields = action.response;
        draftState.error = null;

        return;

      case CONTACT_CUSTOM_FIELD_CREATE_FAILURE:
      case CONTACT_CUSTOM_FIELD_EDIT_FAILURE:
      case CONTACT_CUSTOM_FIELDS_SEQUENCE_EDIT_FAILURE:
        draftState.isFetching = true;
        draftState.error = action.error;

        return;

      case CONTACT_CUSTOM_FIELD_CREATE_SUCCESS:
      case CONTACT_CUSTOM_FIELD_EDIT_SUCCESS:
      case CONTACT_CUSTOM_FIELD_FETCH_SUCCESS:
        draftState.isFetching = true;
        draftState.currentContactCustomField = action.response;
        draftState.error = null;

        return;

      case CONTACT_CUSTOM_FIELD_FETCH_FAILURE:
        draftState.isFetching = true;
        draftState.currentContactCustomField = null;
        draftState.error = action.error;

        return;

      case CONTACT_CUSTOM_FIELDS_SEQUENCE_EDIT_SUCCESS:
        draftState.isFetching = true;
        draftState.contactCustomFields = action.response;
        draftState.error = null;

        return;
    }
  });
